<table>
    <thead>
        <tr>
            <th class="string">{{'consumos.reimpresiones.seriado.snc' | translate}}</th>
        </tr>
    </thead>
    <tbody *ngFor="let seriado of seriados; let i = index">
        <tr *ngIf="i < lastItemList && i >= firstItemList">
            <td class="string">{{seriado.snc}}</td>
        </tr>
    </tbody>
    <tfoot>
      <tr>
          <td colspan="3">
              <app-paginator *ngIf="seriados && seriados.length > 0" [itemsPerPage]="itemsPerPage"
                  [currentPage]="currentPage" [totalItems]="totalItems" [visiblePages]="visiblePages" [hiddeItems]="true"
                  (pageChange)="pageChange($event)"></app-paginator>
          </td>
      </tr>
  </tfoot>
</table>
